<!-- User BODY -->
<body class="hero" style="font-family: 'Poppins', sans-serif;">
  <div style="background-color: white"></div>
  

  <div class="wrapper" style="font-size: large;">

    <div id="formContent" class="text_select" style="border-radius: 50px;">
      <!-- <div *ngIf="router.url === '/signin'">
      <a><h2 class="underlineHover signingbutton" routerLink="/signin" id="login" routerLinkActive="active" style="margin-bottom: 20px; cursor: pointer;" > Sign In </h2></a>
    </div>
<br>
    <div *ngIf="router.url === '/signup'">
      <a><h2 class="underlineHover signingbutton" routerLink="/signup" id="reg" routerLinkActive="active" style="margin-bottom: 30px; cursor: pointer;" > Sign Up </h2></a>
    </div> -->
      <router-outlet></router-outlet>
    </div>
    </div>


 
